import React from 'react';
import { PoolDetail } from '@/types/pool';
import { Button } from '../../ui/Button';
import { InformationBox } from './InformationBox';
import { LoanTermsInfoDisplay } from './LoanTermsInfoDisplay';

type OfferFormStepProps = {
  pool: PoolDetail;
  onSendOffer: () => void;
  isSubmitting: boolean;
  error?: string | null;
};

export const OfferFormStep: React.FC<OfferFormStepProps> = ({ pool, onSendOffer, isSubmitting, error }) => {
  return (
    <div className="p-8 flex flex-col gap-6">
      {/* Offer Details - Two Columns */}
      <LoanTermsInfoDisplay loanTerms={pool.loan_terms} />

      {/* Information Section */}
      <InformationBox
        title="Once you send your offer:"
        items={[
          'The borrower will review and can either accept or reject the offer.',
          'If accepted, you will be directed to open escrow',
        ]}
      />

      {/* Error Message */}
      {error && (
        <div
          className="bg-red-50 border border-red-200 text-[#DC2626] p-3 rounded-lg text-sm"
          style={{
            fontFamily: 'var(--ep-font-avenir)',
          }}
        >
          {error}
        </div>
      )}

      {/* Action Buttons */}
      <div className="flex gap-4 justify-start pt-2">
        <Button onClick={onSendOffer} variant="primary" disabled={isSubmitting} loading={isSubmitting}>
          Send the offer
        </Button>
      </div>
    </div>
  );
};
